import React, { useState } from "react";
import { styled } from '@mui/styles';
import ProtoHeader from "../components/ProtoHeader";
import Footer from "../components/Footer";
import {
    CssBaseline,
    Paper as MuiPaper,
} from "@mui/material";

//const GlobalStyle = createGlobalStyle`
//  html,
//  body,
//  #root {
//    height: 100%;
//  }

//  body {
//    background: ${props => props.theme.body.background};
//  }

//  .MuiCardHeader-action .MuiIconButton-root {
//    padding: 4px;
//    width: 28px;
//    height: 28px;
//  }
//`;


const Root = styled('div')({
    display: 'flex',
    minHeight: '100vh'
});

const AppContent = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
});

const Paper = styled(MuiPaper);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${props => props.theme.body.background};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

const ProtoLayout = ({ children }) => {

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Root>
            <CssBaseline />
            {/*<GlobalStyle />*/}
            <AppContent>
                <ProtoHeader onDrawerToggle={handleDrawerToggle} />
                <MainContent p={5} pt={1} pb={1}>
                    {children}
                </MainContent>
                <Footer />
            </AppContent>
        </Root>
    );
}

export default ProtoLayout;



